/*!
 * voices.js — the sounding voices, by uid
 * © 2026 Rob Canning — GPLv3
 *
 * The audio files' voices (audioFile.js) and the synths' (synth.js), in
 * a module of their own that makes no sound, so level, solo and vu read
 * them by import -- synth.js imports those, and they could not import it
 * back -- and node tests load them. Also on window, where extensions and
 * the test rigs look.
 */

export const activeAudioCues = window.activeAudioCues || (window.activeAudioCues = new Map());
export const activeSynthVoices = window.activeSynthVoices || (window.activeSynthVoices = new Map());

/** The synths sounding, by name: a voice's uid is name__n (synth.js). */
export function synthNames() {
  return [...new Set([...activeSynthVoices.keys()].map(k => String(k).split("__")[0]))];
}
